import "core-js/modules/es6.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

function NavigationItems(_ref) {
  var items = _ref.items;
  return React.createElement("ul", null, items.map(function (item, i) {
    return React.createElement("li", {
      key: item.path + '_' + i
    }, item.path ? React.createElement(Link, {
      to: item.path
    }, item.title) : // eslint-disable-next-line
    React.createElement("a", null, item.title), item.items && item.items.length && React.createElement(NavigationItems, {
      items: item.items
    }));
  }));
}

NavigationItems.propTypes = {
  items: PropTypes.array.isRequired
};
export default NavigationItems;